import Vue from "vue";
import Router from "vue-router";
import LayoutDefault from "../layouts/LayoutDefault";
import Layout404 from "../layouts/Layout404";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { store } from "../store";

const Home = () => import("../views/Home");

const TestLoginBig = () => import("../components/TestLoginBig");

const Error404 = () => import("../views/Error404");

const Poplatky = () => import("../views/Poplatky");

const Poplatek = () => import("../views/Poplatek");

const HrazenyPoplatek = () => import("../views/HrazenyPoplatek");
const Cart = () => import("../views/Cart");
const QrPayment = () => import("../views/QrPayment");
const ProhlaseniOPristupnosti = () =>
  import("../views/ProhlaseniOPristupnosti");
const LoginError = () => import("../views/LoginError");
const AutorizaceUkonu = () => import("../views/AutorizaceUkonu");
const Payment = () => import("../views/Payment");
const PaymentConfirmation = () => import("../views/PaymentConfirmation");
const Kontakty = () => import("../views/Kontakty");
const Podminky = () => import("../views/Podminky");
const Protection = () => import("../views/Protection");

const Formulare = () => import("../views/Formulare");
const Formular = () => import("../views/Formular");
const OsvedceniZadosti = () => import("../views/OsvedceniZadosti");

const StavyZadosti = () => import("../views/StavyZadosti");
const StavZadosti = () => import("../views/StavZadosti");


const UhrazenePoplatky = () => import("../views/UhrazenePoplatky");
const UhrazenyPoplatek = () => import("../views/UhrazenyPoplatek");

Vue.use(Router);

const router = new Router({
  mode: "history", // abychom meli url bez hash krizku
  routes: [
    {
      path: "/:customerUuid",
      name: "home",
      component: Home,
      meta: { layout: LayoutDefault },
    },
    {
      path: "/:customerUuid/kontakty",
      name: "kontakty",
      component: Kontakty,
      meta: { layout: LayoutDefault, requiresAuth: false },
    },
    {
      path: "/:customerUuid/podminky",
      name: "podminky",
      component: Podminky,
      meta: { layout: LayoutDefault, requiresAuth: false },
    },
    {
      path: "/:customerUuid/formulare",
      name: "formulare",
      props: true,
      component: Formulare,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/formular",
      name: "formular",
      props: true,
      component: Formular,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/formular/osvedceni",
      name: "osvedceniZadosti",
      props: true,
      component: OsvedceniZadosti,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },

    {
      path: "/:customerUuid/stavyzadosti",
      name: "stavyZadosti",
      props: true,
      component: StavyZadosti,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/stavzadosti",
      name: "stavZadosti",
      props: true,
      component: StavZadosti,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },

    {
      path: "/:customerUuid/poplatky",
      name: "poplatky",
      props: true,
      component: Poplatky,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/poplatek",
      name: "poplatek",
      props: true,
      component: Poplatek,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/hrazenypoplatek",
      name: "hrazenypoplatek",
      props: true,
      component: HrazenyPoplatek,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/uhrazene",
      name: "uhrazene",
      component: UhrazenePoplatky,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/uhrazeny",
      name: "uhrazeny",
      props: true,
      component: UhrazenyPoplatek,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/ochrana",
      name: "ochrana",
      props: true,
      component: Protection,
      meta: { layout: LayoutDefault, requiresAuth: false },
    },
    {
      path: "/:customerUuid/cart",
      name: "cart",
      component: Cart,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/qrPayment",
      name: "qrPayment",
      component: QrPayment,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/aduConfirmation",
      name: "autorizace-ukonu",
      component: AutorizaceUkonu,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/payment",
      name: "payment",
      component: Payment,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/payment-confirmation",
      name: "payment-confirmation",
      component: PaymentConfirmation,
      meta: { layout: LayoutDefault, requiresAuth: true },
    },
    {
      path: "/:customerUuid/prohlaseni-o-pristupnosti",
      name: "prohlaseni-o-pristupnosti",
      component: ProhlaseniOPristupnosti,
      meta: { layout: LayoutDefault },
    },
    {
      path: "/:customerUuid/login",
      name: "Login",
      beforeEnter() {
        store.dispatch("resetLocalState");
        store.dispatch("resetSessionState");
        // http://localhost:8081/saml/login/alias/testovaci-obec
        window.location =
          process.env.VUE_APP_BASE_URL +
          "/saml/login/alias/" +
          (window.location.pathname.substring(1) || "defaultAlias");
      },
    },
    {
      path: "/:customerUuid/testlogin",
      name: "TestLogin",
      component: TestLoginBig,
      meta: { layout: LayoutDefault },
    },
    {
      path: "/:customerUuid/logout",
      name: "Logout",
      beforeEnter() {
        store.dispatch("resetAndSetGlobalLoadingToTrue");
        window.location =
          process.env.VUE_APP_BASE_URL +
          "/saml/logout/alias/" +
          (window.location.pathname.substring(1) || "defaultAlias");
      },
    },
    {
      path: "/:customerUuid/login-error",
      name: "Chyba při přihlášení",
      component: LoginError,
      meta: { layout: LayoutDefault },
      // message predaveme jako query param v Base64
      props: route => ({
        message: decodeURIComponent(
          atob(route.query.reason).replace(/\+/g, "%20"),
        ),
      }),
    },
    {
      path: "/:customerUuid/*",
      name: "error404CustomerUuid",
      component: Error404,
      meta: { layout: Layout404 },
    },
    {
      path: "/",
      name: "landing",
      beforeEnter() {
        window.location.href = "https://www.alis.cz/sluzby-na-webu";
      }
    },
    // vše ostatní redirectujeme na root
    {
      path: "*",
      name: "notFound",
      component: Error404,
      meta: { layout: Layout404 },
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.dispatch("setHtmlError", "");

  // Check if we're redirecting to the home page and we have a saved page to redirect to
  // This happens after SAML authentication redirects back to the application
  if (to.name === 'home' && store.state.lastVisitedPage) {
    const redirectPath = store.state.lastVisitedPage;
    store.dispatch("setLastVisitedPage", null);
    next(redirectPath);
  } else
    next(); // nakonec vždy voláme next()!
});

/* eslint-disable */

// progress bar
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});
/* eslint-enable */

export default router;
